import axios from '../../../services/axios.service';
import { getEndpointBase } from '../../../services/api.service';
import { AxiosResponse } from 'axios';

export const systemControlService = {
  importUsers: (): Promise<AxiosResponse> => {
    return axios.post(getEndpointBase(`panel/system/emc`));
  }
};
